import BaseAPI from "../api";

const path: string = "district";

export class DistrictApi extends BaseAPI {
  static getAllDistrict(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static createDistrict(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getDistrictByProvince(id: number, query?: any): Promise<any> {
    return this.api.get(`${path}/find-by-province/${id}`, {
      params: { ...query },
    });
  }

  static updateDistrict(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteDistrict(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getDistrictById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/get-by-id`);
  }
}